import React, { PureComponent, Fragment } from 'react';
import {
  Box,
  Typography,
  Grid,
  Divider,
  IconButton,
  TextField,
  Tooltip,
  Tabs,
  Tab,
  withStyles,
} from '@material-ui/core';
import { ArrowBack, FilterListOutlined, Close } from '@material-ui/icons';
import SearchIcon from '@material-ui/icons/Search';
import TopBarFilters from './topBarFilters';

import './sections.scss';

const sourceIndexMap = {
  applicants: 0,
  leads: 1,
  covid: 2,
};

const styles = {
  topBar: {
    height: 52,
    width: '100%',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    margin: '52px 0 0',
    background: '#fbfbfb',
  },
  jobTitleContainer: {
    height: '100%',
  },
  jobTitleText: {
    color: 'rgba(0, 0, 0, 0.6)',
    letterSpacing: '0.24px',
    lineHeight: 1.36,
    fontSize: '14px',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginLeft: '10px',
  },
  tabsAndSearchContainer: {
    paddingLeft: '16px',
  },
  tabsContainer: {
    marginBottom: '4px',
  },
  tabText: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: 1.36,
    textTransform: 'none',
  },
  talentCountText: {
    backgroundColor: '#777D83',
    color: '#ffffff',
    padding: '1px 10px',
    borderRadius: '3px',
    fontSize: '0.75em',
    marginLeft: '5px',
  },
};

class TopBar extends PureComponent {
  constructor(props) {
    super();
    this.state = {
      showSearch: false,
      searchText: '',
      anchorEl: null,
      value: sourceIndexMap[props.source],
      isSearched: false,
    };
  }

  onSearchTextChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  onHideTextField = () => {
    this.setState({
      searchText: '',
      showSearch: false,
    });
  };

  onEnterKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.handleCandidateSearch();
    }
  };

  handleCandidateSearch = () => {
    const { searchText, showSearch } = this.state;
    if (searchText.trim() && showSearch) {
      this.props.onSearchCandidate({ searchText: this.state.searchText });
      this.setState({ isSearched: true });
    } else {
      this.setState({ showSearch: true });
    }
  };

  resetSearch = () => {
    const { applyFilters } = this.props;

    applyFilters(true);
    this.setState({ isSearched: false, showSearch: false, searchText: '' });
  };

  handleDelete = (e) => {
    this.setState({ anchorEl: e.currentTarget });
  };

  handleClose = (e) => {
    this.setState({ anchorEl: null });
  };

  getJobRole = () => {
    const { jobRole, onBackClick, jobId, path, history, classes } = this.props;

    // const classes = {};
    return (
      <>
        <Grid item xs={2}>
          <Box display="flex" alignItems="center">
            <IconButton onClick={onBackClick}>
              <ArrowBack />
            </IconButton>
            <Typography variant="body2">{jobRole}</Typography>
          </Box>
        </Grid>
        {path === 'screened-pipe' ? (
          <Grid item xs={8}>
            <Grid container classes={{ root: classes.tabsAndSearchContainer }}>
              <Grid item xs={4} classes={{ root: classes.tabsContainer }}>
                <Tabs
                  value={1}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={() =>
                    history.push(`/applicants-dashboard/${jobId}`)
                  }
                  aria-label="Nav Tabs"
                  classes={{ flexContainer: classes.tabsContainer }}
                >
                  <Tab
                    label={
                      <Typography classes={{ root: classes.tabText }}>
                        Dashboard
                      </Typography>
                    }
                  />
                  <Tab
                    label={
                      <Typography classes={{ root: classes.tabText }}>
                        Applicants
                        {/* {pipeline.totalLeads ? (
                    <span className={classes.talentCountText}>
                      {pipeline.totalLeads}
                    </span>
                  ) : (
                    ''
                  )} */}
                      </Typography>
                    }
                  />
                </Tabs>
              </Grid>
            </Grid>
          </Grid>
        ) : null}
      </>
    );
  };

  getOtherLinks = () => {
    const { searchText, showSearch, anchorEl, isSearched } = this.state;
    const {
      toggleState,
      source,
      filters,
      filterCount,
      onAutoSuggestFilterChange,
      onResetScore,
      onResetVisaSponsorship,
      onResetExperience,
      resetFilters,
      visaFilter,
      isFiltered,
    } = this.props;

    this.setState({
      value: sourceIndexMap[source],
    });
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
      <Fragment>
        <Divider />
        <Grid
          item
          style={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          }}
        >
          {isFiltered && filterCount > 0 && (
            <TopBarFilters
              id={id}
              open={open}
              anchorEl={anchorEl}
              handleClose={this.handleClose}
              handleDelete={this.handleDelete}
              filters={filters}
              visaFilter={visaFilter}
              filterCount={filterCount}
              onAutoSuggestFilterChange={onAutoSuggestFilterChange}
              onResetScore={onResetScore}
              onResetVisaSponsorship={onResetVisaSponsorship}
              onResetExperience={onResetExperience}
              resetFilters={resetFilters}
            />
          )}
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          }}
        >
          {showSearch && (
            <TextField
              id="standard-basic"
              value={searchText}
              onChange={this.onSearchTextChange}
              style={{ marginTop: '6px' }}
              onKeyPress={this.onEnterKeyPress}
            />
          )}
          <Tooltip title="Search Talent by name, skills, company name or job roles">
            {isSearched ? (
              <IconButton onClick={this.resetSearch}>
                <Close />
              </IconButton>
            ) : (
              <IconButton onClick={this.handleCandidateSearch}>
                <SearchIcon />
              </IconButton>
            )}
          </Tooltip>
          <Tooltip title="Filter Talent">
            <IconButton onClick={toggleState('isFiltersOpen')}>
              <FilterListOutlined />
            </IconButton>
          </Tooltip>
        </Grid>
      </Fragment>
    );
  };

  render() {
    const { fromPage } = this.props;
    return (
      <Fragment>
        <Box pt="54px" />
        <Grid container spacing={0}>
          {this.getJobRole()}
          {fromPage && fromPage === 'jobView' ? null : this.getOtherLinks()}
        </Grid>
      </Fragment>
    );
  }
}

export default withStyles(styles)(TopBar);
